import React from 'react';
import CustomStyledText from '../UI/CustomStyledText/CustomStyledText';
import styles from './HeroTitle.module.scss';

const HeroTitle = ({ titleConfig }) => {
    if (!titleConfig?.hasTitle) return null;

    const hasCustomWeight = !!titleConfig?.textStyle?.fontWeight;

    return (
        <>
            {titleConfig.text && (
                <CustomStyledText
                    tag="h1"
                    styleConfig={titleConfig.textStyle}
                    className={`${hasCustomWeight ? '' : 'fw-bold'} display-5 mb-2 ${styles.titleText}`.trim()}
                >
                    {titleConfig.text}
                </CustomStyledText>
            )}
            {titleConfig.subtitleText && (
                <CustomStyledText
                    tag="p"
                    styleConfig={titleConfig.subtitleStyle}
                    className={`lead mb-0 d-none d-sm-block ${styles.subtitleText}`}
                >
                    {titleConfig.subtitleText}
                </CustomStyledText>
            )}
        </>
    );
};

export default HeroTitle;
